
import { useReducer } from 'react'

import { Model } from '../models/model'
import { cobroReducer } from '../reducers/cobroReducer'

const initialState = {
    detailCobro: {
        id: 0,
        id_cliente: 0,
        cliente: '',
        fecha_cobro: new Date(),
        id_tipo_cobro: 0,
        id_cta_bancaria: 0,
        numero_operacion: '',
        total_cobro: 0,
        id_factura: 0,
        id_moneda: 0,
        simbolo: "S/",
        separacion_miles: ",",
        separacion_decimales: ".",
        factura_total: 0,
        factura_total_cobrado: 0,
        factura_total_por_cobrar: 0,
        reading_mode: false
    },
    cobros: []
}

export const useCobros = () => {

    const [state, dispatch] = useReducer(cobroReducer, initialState)
    const { cobros, detailCobro } = state

    const initCreateNewCobro = async (dataFactura) => {
        
        const newCobro = {
            ...detailCobro,
            id:0,
            reconciled:false,
            reconciliation:null,
            id_cliente: dataFactura.id_cliente,
            cliente: dataFactura.cliente,
            fecha_cobro: new Date(),
            total_cobro: dataFactura.total_por_cobrar,
            id_factura: dataFactura.id,
            id_moneda: dataFactura.id_moneda,
            simbolo: dataFactura.simbolo,
            separacion_miles: dataFactura.separacion_miles,
            separacion_decimales: dataFactura.separacion_decimales,
            factura_total: dataFactura.total_factura,
            factura_total_cobrado: dataFactura.total_cobrado,
            factura_total_por_cobrar: dataFactura.total_por_cobrar
        }

        const action = {
            type: '[COBRO] set detail',
            payload: newCobro
        }

        dispatch(action)

    }

    const initGetCobrosByFactura = async (facturaId) => {

        const params = {
            url: `cobros/byFactura/${facturaId}`
        }

        const resultDataList = await Model.getAll(params);

        const action = {
            type: '[COBRO] Load list',
            payload: resultDataList
        }

        dispatch(action)
    }

    const initGetOneCobro = async (cobroId) => {

        const params = {
            url: `cobros/${cobroId}`
        }

        const dataOne = await Model.getOne(params)

        const action = {
            type: '[COBRO] set detail',
            payload: dataOne
        }

        dispatch(action)

    }

    const initSaveCobro = async (newCobro) => {

        const params = {
            url: 'cobros',
            dataForm: newCobro
        }

        const resultId = await Model.save(params)

        const newDetail = {
            ...newCobro,
            id: resultId
        }

        if (resultId) {

            const action = {
                type: '[COBRO] set detail',
                payload: newDetail
            }

            dispatch(action)

        }

    }

    const initUpdateCobro = async (dataCobro) => {

        const params = {
            url: `cobros/${dataCobro.id}`,
            dataForm: dataCobro
        }

        const dataUpdate = await Model.update(params)

        const action = {
            type: '[COBRO] set detail',
            payload: dataUpdate
        }

        dispatch(action)

    }

    const initDeleteCobro = async (cobroId) => {

        const params = {
            url: `cobros/${cobroId}`,
        }

        return await Model.delete(params)

    }

    return {
        cobros,
        detailCobro,
        initGetCobrosByFactura,
        initCreateNewCobro,
        initGetOneCobro,
        initSaveCobro,
        initUpdateCobro,
        initDeleteCobro
    }

}
